import React, { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        'h-10 w-full rounded-lg border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary shadow-xs outline-none transition duration-200',
        'placeholder:text-text-placeholder',
        'hover:border-border-brand hover:bg-bg-primary_hover',
        'focus:border-border-brand focus:ring-4 focus:ring-ring-brand/24',
        'disabled:cursor-not-allowed disabled:bg-bg-disabled disabled:text-text-disabled disabled:opacity-75',
        className,
      )}
      {...props}
    />
  );
});

Input.displayName = 'Input';
